<template>
  <v-container
    id="RFIDDevice"
    fluid
    tag="section"
    class="full-height"
  >
    <base-v-component
      heading="RFID Устройство"
      goBackText="Обратно към инвентаризации"
      goBackTo="/inventories"
    />

    <v-row class="mt-10 d-print-none">
      <v-col cols="12" xl="4" lg="5" md="5" class="mx-auto">
        <base-material-card 
          hover-reveal
          icon="mdi-clipboard-check-outline"
          color="primary"
          expandable
          expandableTitle="Детайли"
          :expanded.sync="expandRFIDDetails"
          :areAllCardsExpanded="areAllCardsExpanded"
          @collapseAllCards="collapseAllCards"
          @expandAllCards="expandAllCards"
        >
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              Свързване с устройството
            </div>
          </template>

          <v-container class="py-7">
            <v-form
              ref="form"
              lazy-validation
            >
              <v-row>
                <v-col cols="12">
                  <base-select
                      :items="device.availablePorts"
                      v-model="device.port"
                      label="Порт"
                  />
                </v-col>
                <v-col cols="12">
                  <v-btn 
                    block
                    :color="device.state ? 'error' : 'success'"
                    @click="toggleConnection"
                  >
                    {{device.state ? "Прекъсни връзка" : "Свържи се"}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </base-material-card>
      </v-col>

      <v-col cols="12" xl="7" lg="7" md="7" class="mx-auto">
        <base-material-card 
          hover-reveal
          icon="mdi-clipboard-text-outline"
          color="primary"
          expandable
          expandableTitle="Данни от RFID"
          :expanded.sync="expandRFIDDataDetails"
          :areAllCardsExpanded="areAllCardsExpanded"
          @collapseAllCards="collapseAllCards"
          @expandAllCards="expandAllCards"
        >
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              Данни от устройството
            </div>
          </template>
          <v-container class="py-7">
            <v-card-text class="pt-0">
              <template v-if="!device.state">
                <v-card color="blue lighten-3">
                  <v-card-text class="text-center">
                    Моля свържете се с устройството първо
                  </v-card-text>
                </v-card>
              </template>
              <template v-else>
                <v-col md="12">
                  <v-tabs
                    v-model="currentTab"
                    fixed-tabs
                    slider-color="primary"
                    class="d-print-none"
                  >
                    <v-tab
                      key="read"
                      href="#tab-read"
                    >
                      Четене
                    </v-tab>
                    <v-tab
                      key="write"
                      href="#tab-write"
                    >
                      Писане
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="currentTab">
                    <v-tab-item
                      key="read"
                      value="tab-read"
                      :transition="false"
                    >
                      <v-card flat>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                readonly
                                v-model="EPCTagRead"

                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="mb-7" v-if="!isEmptyObject(item)">
                            <v-col cols="12">
                              <v-btn text @click="goToItem()" :ripple="false" class="no-background-hover">{{item.name}}</v-btn>
                            </v-col>
                          </v-row>
                          <v-row class="mb-7" v-if="EPCTagRead.length && EPCTagRead.length === 24 && isEmptyObject(item)">
                            <v-col cols="12" class="error lighten-4 pa-5 text-center">
                              Не е намерен артикул с прочетеният етикет.
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-btn
                                color="secondary"
                                @click="readEPC"
                                block
                              >
                                Прочети таг
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item
                      key="write"
                      value="tab-write"
                      :transition="false"
                    >
                      <v-card flat>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="EPCTagWrite"
                                label="EPC таг"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-btn
                                color="secondary"
                                @click="writeEPC"
                                block
                              >
                                Запиши таг
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
                
              </template>
            </v-card-text>
          </v-container>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { mapGetters } from "vuex";
import { RFIDConnect, RFIDDisconnect, RFIDGetAvailablePorts, RFIDGetConnectionState, RFIDGetPortName, RFIDRead, RFIDWrite } from '@/api/rfid';
import { getItemByEPC } from '@/api/items';
import { isEmptyObject } from '@/utils/index';
export default {
  name: "RFIDDevice",
  components: {
  },
  data(){
    return {
      tags: [],
      EPCTagRead: "",
      EPCTagWrite: "",
      device: {
        availablePorts: [],
        port: '',
        state: false,
      },
      item: {},
      currentTab: "tab-read",
      expandRFIDDetails: true,
      expandRFIDDataDetails: true
    }
  },
  computed: {
    ...mapGetters([
      'lastRoute',
      'user'
    ]),
    areAllCardsExpanded(){
      return this.expandRFIDDetails || this.expandRFIDDataDetails;
    },
  },
  mounted(){
    this.getRFIDDetails();
  },
  methods: {
    getRFIDDetails(){
      this.getAvailablePorts();
      this.getConnectionState();
    },
    toggleConnection(){
      if(this.device.state){
        this.disconnect()
      } else {
        this.connect()
      }
    },
    connect(){

      if(this.device && this.device.port && this.device.port.length){
        RFIDConnect(this.device.port).then(response =>{
          if(response === 0){
            this.getConnectionState();
          }
        })
      } else {
        this.$snotify.error("Моля изберете първо порт.")
      }
    },
    disconnect(){
      RFIDDisconnect().then(response => {
        this.device.state = response === true ? true : false;
      })
    },
    getAvailablePorts(){
      RFIDGetAvailablePorts().then(response => {
        this.device.availablePorts = response;
        this.device.port = response[0];
      })
    },
    getRFIDPortName(){
      RFIDGetPortName().then(response => {
        if(response && response.length)
          this.device.port = response;
      })
    },
    getConnectionState(){
      RFIDGetConnectionState().then(response => {
        this.device.state = response === true ? true : false;

        if(this.device.state)
          this.getRFIDPortName();
      })
    },
    readEPC(){
      this.item = {};
      this.EPCTagRead = '';
      RFIDRead().then(response => {
        this.EPCTagRead = response;
        if(response.length && response.length === 24){
          getItemByEPC(response).then(item => {
            this.item = item;
          })
        }

      })
    },
    writeEPC(){
      if(this.EPCTagWrite && this.EPCTagWrite.length == 24){
        RFIDWrite(this.EPCTagWrite).then(() => {})
      } else {
        this.$snotify.error(null, null, {html: "Моля попълнете с 24 символа полето 'EPC таг'"});
      }
    },
    goToItem(){
      if(this.item && this.item._id)
        this.$router.push({path: `/items/${this.item._id}`})
    },
    expandAllCards(){
      this.expandRFIDDetails = true;
      this.expandRFIDDataDetails = true;
      this.$forceUpdate();
    },
    collapseAllCards(){
      this.expandRFIDDetails = false;
      this.expandRFIDDataDetails = false;
      this.$forceUpdate();
    },
    isEmptyObject: isEmptyObject
  }
}
</script>